export default __webpack_public_path__ + "static/c9a7a115c73aa73b0acfbe1c347e9f00.svg";